import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListInboundProgressInput } from "@nexxt/contracts/procurement";
import { inboundQueries } from "@nexxt/procurement-ui";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the inbound expected and received (spec v0.2 §9, P8.10a): one read per page, each PO with its
// inbounds. Under the key of the inbounds: a discrepancy confirmed or settled on an inbound reads the view again.

const progress = api.procurement["inbound-progress"];

type ListPage = InferResponseType<typeof progress.$get, 200>;
export type InboundProgress = ListPage["items"][number];

/** The filters of the list input (`listInboundProgressInput`), without the paging the query adds. */
export type InboundProgressFilters = Pick<ListInboundProgressInput, "season" | "supplier" | "brand" | "stage" | "q"> & {
  discrepancies?: boolean | undefined;
};

const PAGE_SIZE = 50;

const keys = {
  all: [...inboundQueries.all, "progress"] as const,
};

export const inboundProgressQueries = {
  ...keys,

  /** The earliest delivery window first. */
  list: (filters: InboundProgressFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "list", filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          progress.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};
